// =====================================================================
// Design tokens do módulo VOIP — fonte única de verdade visual.
// Mantém widget, aba do chamado e histórico com a MESMA linguagem premium.
// Regra de ouro: superfície colorida SEMPRE com texto branco (vt.onAccent).
// =====================================================================
export const vt = {
  // marca — SEGUE a cor primária do sistema (white-label via CSS var do ThemeLoader).
  // Modo azul → #2979ff ; verde → #8BC34A. Fallback = verde Mexx. Nome "green" mantido por legado.
  // onAccent (#fff) garante contraste do texto/ícone SOBRE qualquer que seja a primária.
  green: 'var(--mexx-green-primary, #8BC34A)',
  greenSoft: 'var(--mexx-green-subtle, #F1F8E9)',
  greenGrad: 'linear-gradient(135deg, var(--mexx-green-primary, #7CB342) 0%, var(--mexx-green-dark, #558B2F) 100%)',
  greenGradHover: 'linear-gradient(135deg, var(--mexx-green-dark, #6FA838) 0%, var(--mexx-green-dark, #4A7B29) 100%)',
  // tom escuro da primária p/ texto/ícone sobre greenSoft (era #558B2F fixo)
  onSoft: 'var(--mexx-green-dark, #558B2F)',

  blue: '#2563EB',
  blueSoft: '#EFF4FF',
  red: '#EF4444',
  redGrad: 'linear-gradient(135deg, #F05252 0%, #DC2626 100%)',
  amber: '#F59E0B',

  // neutros
  ink: '#0F172A',
  text: '#1E293B',
  textSoft: '#64748B',
  muted: '#94A3B8',
  border: '#E9EDF2',
  borderStrong: '#DCE2EA',
  surface: '#FFFFFF',
  surfaceAlt: '#F8FAFC',
  onAccent: '#FFFFFF',

  // estados de cabeçalho escuro (widget)
  slate: 'linear-gradient(135deg, #233044 0%, #0F172A 100%)',
  slateBlue: 'linear-gradient(135deg, #1D4ED8 0%, #1E3A8A 100%)',

  // elevação
  shadowSm: '0 1px 2px rgba(16,24,40,.05), 0 1px 3px rgba(16,24,40,.07)',
  shadowMd: '0 4px 12px rgba(16,24,40,.08), 0 2px 4px rgba(16,24,40,.04)',
  shadowPop: '0 16px 40px rgba(16,24,40,.20), 0 4px 12px rgba(16,24,40,.10)',

  radius: 16,
  radiusSm: 12,
  radiusXs: 10,
};

export const presenceColors = {
  available: '#22C55E',
  busy: '#F59E0B',
  offline: '#94A3B8',
};

// botão de ação primário (verde, texto branco garantido)
export const primaryBtnSx = {
  background: vt.greenGrad,
  color: vt.onAccent,
  fontWeight: 700,
  textTransform: 'none',
  letterSpacing: 0.2,
  boxShadow: '0 6px 16px rgba(16,24,40,.18)',
  '&:hover': { background: vt.greenGradHover, boxShadow: '0 8px 20px rgba(16,24,40,.22)' },
};

export const cardSx = {
  background: vt.surface,
  border: `1px solid ${vt.border}`,
  borderRadius: `${vt.radius}px`,
  boxShadow: vt.shadowSm,
};
